<template>
  <div v-bind="getRootProps()" class="dropzone">
    <input v-bind="getInputProps()" />
    <div class="inner" :class="{ isMin: isMinMode }">
      <i class="fal fa-cloud-upload text-muted mb-3 dzlogo"></i>
      <!-- <p v-if="isDragActive">そのままドロップしてください ...</p> -->
      <p v-if="isDragReject">3MB以内のPDFファイルを1つドロップしてください</p>
      <p v-else-if="isDragAccept">そのままドロップしてください ...</p>
      <p v-else>ファイルをドロップするか、クリックして選択 ...</p>
      <p
        v-if="isRejected"
        class="fw-700 text-capitalize color-danger-300 fs-lg"
        style="position: relative; top: -8px"
      >
        3MB以内のPDFファイルを1つドロップしてください
      </p>
    </div>
  </div>
  <!-- <button @click="open">open</button> -->
</template>

<script lang="ts">
import { useDropzone } from "vue3-dropzone";
import { defineComponent, PropType, ref } from "vue";
import { Cl_common } from "@/functions/Cl_common";

// fileInfo オブジェクトの型を定義します
interface FileInfo {
  path: string;
  name: string;
  size: number;
  type: string;
  lastModified: number;
  data: any;
  isExecute: boolean;
  isRejected: boolean;
}

export default {
  name: "Or_fileupload",

  props: {
    fileInfo: {
      type: Object as PropType<FileInfo>,
      required: true,
    },
    updateFileInfo: {
      type: Function as PropType<(file: FileInfo) => void>,
      required: true,
    },
    isMinMode: {
      type: Boolean as PropType<boolean>,
      required: false,
      default: false,
    },
  },

  setup(props: any) {
    const isRejected = ref(false);

    function onDrop(acceptFiles: any, rejectReasons: any) {
      props.updateFileInfo({
        path: "",
        name: "",
        size: -1,
        type: "",
        lastModified: "",
        data: null,
        isExecute: false,
      });

      Cl_common.logger("acceptFiles");
      Cl_common.logger(acceptFiles);
      Cl_common.logger("rejectReasons");
      Cl_common.logger(rejectReasons);
      isRejected.value = false;

      if (acceptFiles.length != 1 || rejectReasons.length != 0) {
        isRejected.value = true;
        return;
      }

      const newFileInfo = {
        path: acceptFiles[0].path,
        name: acceptFiles[0].name,
        size: acceptFiles[0].size,
        type: acceptFiles[0].type,
        lastModified: acceptFiles[0].lastModified,
        data: acceptFiles[0],
        isExecute: true,
      };

      // 親コンポーネントのメソッドを使って fileInfo を更新
      props.updateFileInfo(newFileInfo);
    }

    const { getRootProps, getInputProps, ...rest } = useDropzone({
      onDrop,
      maxFiles: 1,
      maxSize: 3000000,
      accept: ".pdf",
    });

    return {
      getRootProps,
      getInputProps,
      isRejected,
      ...rest,
    };
  },
};
</script>
<style scoped>
.dropzone {
  width: 100%;
  height: 100%;
  border: 2px dashed #dedede;
  border-radius: 5px;
  background: #f5f5f5;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  padding: 0.5rem;
  text-align: center;
  position: relative;
}
.inner {
  width: 80%;
  margin: 0 auto;
  text-align: center;
  font-weight: bold;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  width: 80%;
  height: 3.2rem;
}
.dzlogo {
  font-size: 4rem;
}

.isMin {
  height: unset !important;
  padding-top: 15px;
}
</style>
